'use client';

import { c as _c } from "react/compiler-runtime";
import '@/global.css';
import * as Sentry from '@sentry/nextjs';
import classnames from 'classnames';
import { useEffect } from 'react';
import Body from '@/components/body';
import ErrorTitle from '@/components/error-title';
import ErrorView from '@/views/error-view';
import Html from '@/components/html';
import locales from '@cache/locales.json';
const className = classnames('flex', 'flex-1', 'justify-center', 'items-center', 'min-h-full', 'sm:container', 'mx-auto', 'px-3');
interface Props {
  error: Error & {
    digest?: string;
  };
}
const GlobalError = t0 => {
  const $ = _c(5);
  const {
    error
  } = t0;
  let t1;
  let t2;
  if ($[0] !== error) {
    t1 = () => {
      Sentry.captureException(error);
    };
    t2 = [error];
    $[0] = error;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <head><link rel="stylesheet" href="/theme.css" /></head>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Html locale={locales.defaultLocale}>{t3}<Body><main className={className}><ErrorView name="personly"><ErrorTitle>An Error Has Occurred</ErrorTitle></ErrorView></main></Body></Html>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export default GlobalError;